import http from '@/utils/request';

// 分账申请列表 + 分账单管理列表
export const getDivideBopList = (data = {}) => {
  return http.post({
    url: '/receipt/divide/bopList',
    data,
  });
};

// 分账单管理列表-分账单详情
export const getDivideDetail = (divideNo = '') => {
  const url = `/receipt/divide/detail/${divideNo}`;
  return http.post({
    url,
  });
};

// 分账重试
export const divideRetry = (data) => {
  return http.post({
    url: '/receipt/divide/retry',
    data,
  });
};

// 分账单管理列表-报表导出
export const DIVIDE_EXPORT_URL = '/receipt/export/divide';

// 分账审核列表-分账申请审核操作
export const setDivideApproval = (data = {}) => {
  const url = '/receipt/divide/approval';
  return http.post({
    url,
    data,
  });
};

// 分账审核列表-分账申请详情
export const getDivideApplyDetail = (data = {}) => {
  const url = '/receipt/divide/detail';
  return http.post({
    url,
    data,
  });
};

// 分账审核导出
export const APPROVAL_DIVIDE_EXPORT = '/receipt/export/waitApprovalDivide';
